/** Master/detail routes whose `:id` selects within one page (no focus move on selection). */
const MASTER_DETAIL = /^(\/business\/(?:subscribers|affiliates|statements))(?:\/[^/]+)?\/?$/;

/** The navigation "page" a pathname belongs to: a master/detail selection maps to its list. */
export function pageKey(pathname: string): string {
  const match = MASTER_DETAIL.exec(pathname);
  return match?.[1] ?? (pathname.replace(/\/$/, '') || '/');
}
